/**
 * 移动端使用的全局状态管理
 * TODO：目前 Fotor 与 GoArt 都共用一个 this.$mobile.
 */

import { isInAppBrower } from "~/utils/common";

function createConfirmData() {
    return {
        show: false,
        title: "",
        content: "",
        cancelBtnText: "Cancel",
        confirmBtnText: "OK",
        hideCancelBtn: false,//隐藏取消按钮
        cancelBtnClick: 'default',
        btnDirection: "Horizontal",//按钮布局方向
    };
}

function createDefaultState () {
    let isInApp = false;
    if (process.client) {
        isInApp = !!isInAppBrower()
    }
    return {
        isInApp,//是否在APP内
        openInAppData: {
            schema: "",
            show: true,
        },//goart底部通用 [APP 内打开] 按钮
        fullLoadingData: {
            show: false,
            text: "",
            theme: "Light"
        },//是否显示全屏loading
        toastLoadingData: {
            show: false,
            text: "",
            htmlContent: "",
            theme: "Light"
        },//是否显示 toast loading
        msgBoxData: {
            show: false,
            content: "",
            btnText: "好的",
            btnClick: "",
        },//弹窗消息数据
        toastData: {
            show: false,
            content: ""
        },//toast 消息数据
        confirmData: createConfirmData(),//confirm 数据


        //GoArt Data
        GoArtHeadBarHeight: 0,
    }
}

export const state = () => createDefaultState()

export const mutations = {
    setMobileState (state, { key, value }) {
        if (Object.prototype.toString.call(value) === "[object Object]") {
            state[key] = { ...value };
        }
        else if (Object.prototype.toString.call(value) === "[object Array]") {
            state[key] = [...value];
        }
        else {
            state[key] = value;
        }

    },
    setMsgBoxData (state, value) {
        state.msgBoxData.btnClick = () => {
            state.msgBoxData.show = false;
        }
        state.msgBoxData = Object.assign({}, state.msgBoxData, value);
    },
    setToastData (state, value) {
        state.toastData = { ...state.toastData, ...value }
    },
    setConfirmData (state, value) {
        if(value.cancelBtnClick === 'default'){
            value.cancelBtnClick = () => {
                this.commit("mobile/setConfirmShow" ,false);
            }
        }
        state.confirmData = { ...createConfirmData(), ...value }
    },
    setConfirmShow(state, value) {
        state.confirmData.show = value;
    }
}

export default {
    namespaced: true,
    state,
    mutations
}